import modal from 'store/modal';

export function useModal() {
  return modal;
}
